<template>
  <div class="wrapper">
    <!-- <div class="patient" @click="showNation = true">
      <span>当前就诊人：</span>
      <span class="name">{{ selectdata.patientname }}</span>
      <img src="@/assets/appointment/jtr_icon.png" />
    </div> -->
    <van-tabs v-model="active" title-active-color="#3C9ECF" swipeable>
      <van-tab title="日清单">
        <div class="day_detailed" v-if="dayLists.length">
          <div class="time_date">
            <span style="margin-right: 6px">{{ this.dayendDate?this.section:this.daystartDate }}</span>
            <van-icon name="notes-o" size="26" @click="selectTime" />
          </div>
          <div class="serialNum">住院流水号：{{ detailedUser.inpNo }}</div>
          <ul class="danlistcl">
            <span class="allMoney">
              <span>总金额：</span>
              <span>￥</span>
              <span>{{ dayMoney }}</span>
            </span>
            <li class="title_cl">
              <span>项目名称</span>
              <span>单价(元)</span>
              <span>数量</span>
              <span>金额(元)</span>
            </li>
            <li v-for="(item,index) in dayLists" :key="index">
              <span>{{ item.itemName }}</span>
              <span>{{ (parseInt(item.unitPrice*100)/100).toFixed(2) }}</span>
              <span>{{ Math.abs(parseInt(item.amount)) }}{{ item.unit }}</span>
              <span>{{ ((parseInt(item.unitPrice*100)/100).toFixed(2)*Math.abs(parseInt(item.amount))).toFixed(2) }}</span>
            </li>
          </ul>
        </div>
        <div class="empty_cl" v-else>
          <img src="@/assets/bg/empty.png">
          <span>暂未查询到清单信息</span>
        </div>
      </van-tab>
      <van-tab title="总清单">
        <div class="all_detailed" v-if="showList">
          <div class="time_date">
            {{ this.detailedUser.inpDatetime }} 至 {{ this.detailedUser.outtime }}
          </div>
          <ul class="price_cl">
            <li>住院流水号：{{ detailedUser.inpNo }}</li>
            <li>总费用：{{ datalist.totalMoney }} 元</li>
          </ul>
          <div class="cost_detailed">总费用详情</div>
          <ul class="top">
            <li>项目名称</li>
            <li>单价(元)</li>
            <li>数量</li>
            <li>金额(元)</li>
          </ul>
          <div class="conlist">
            <van-collapse v-model="activeNames" accordion>
              <van-collapse-item
                v-for="(item, index) in itemList"
                :key="index"
                :name="index"
              >
                <template #title>
                  <div style="font-size: 16px;">{{ item.name }}</div>
                </template>
                <ul class="tableCl">
                  <li v-for="(it, dex) in item.list" :key="dex">
                    <span>{{ it.itemName }}</span>
                    <span>{{
                      (parseInt(it.price * 100) / 100).toFixed(2)
                    }}</span>
                    <span>{{ Math.abs(parseInt(it.amount)) }}{{ it.unit }}</span>
                    <span>{{
                      Math.abs((parseInt(it.price * it.amount * 100) / 100).toFixed(2))
                    }}</span>
                  </li>
                </ul>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
        <div class="empty_cl" v-if="!showList">
          <img src="@/assets/bg/empty.png">
          <span>暂未查询到清单信息</span>
        </div>
      </van-tab>
    </van-tabs>
    <!-- <ul class="serve">
      <li @click="btn(1)">入院办理</li>
      <li @click="btn(2)">出院办理</li>
      <li @click="btn(3)">住院总清单（明细）</li>
    </ul> -->
    <van-calendar
      v-model="showdanSel"
      @confirm="onConfirmDan"
      color="#318fe6"
      :min-date="minDate1"
      :max-date="maxDate1"
    />
    <!-- <van-calendar
      v-model="showMoreSel"
      type="range"
      @confirm="onConfirmMore"
      color="#318fe6"
      :min-date="minDate2"
      :max-date="maxDate2"
    /> -->
    <!-- <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup> -->
  </div>
</template>

<script>
import {
  getIpPatBillAll,
  getIpPatientBill
} from "@/request/api.js";

function safeJson(raw, fallback) {
  if (raw == null || raw === "") return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}

function formatYmd(s) {
  return s ? String(s).slice(0, 10) : "";
}

function toFixed2(n) {
  return (Math.round(Number(n || 0) * 100) / 100).toFixed(2);
}

function listToGroup(list) {
  if (!Array.isArray(list) || list.length === 0) return null;
  return { name: list[0].itemTypeName, list };
}
export default {
  data() {
    return {
      active: 0,
      showNation: false,
      // columns: [],
      // selectdata: {},
      detailedUser: {},
      activeNames: 0,
      datalist: {},
      itemList: [],
      showdanSel: false,
      // showMoreSel: false,
      minDate1: "", //日期可选最小值
      maxDate1: "", //日期可选最大值
      // minDate2: "", //日期可选最小值
      // maxDate2: "", //日期可选最大值
      dayLists: [],
      daystartDate: "",
      dayendDate: "",
      section: "",
      dayMoney: 0,
      showList: false
    };
  },
  async created() {
    // 从 GeneralList 带入的住院记录（用于日清单/总清单）
    this.detailedUser = safeJson(sessionStorage.getItem("detailedUser"), {});
    await this.getInfo();
    await this.costList();
  },
  methods: {
    // // 获取所有就诊人
    // async getVisitinfos() {
    //   let openid = sessionStorage.getItem("openid");
    //   let res = await selectVisitinfos({ openid });
    //   // console.log(JSON.parse(JSON.stringify(res.data.obj)));
    //   res.data.obj.forEach(item => {
    //     item.text = item.patientname;
    //     if (item.style == 1) {
    //       this.selectdata = item;
    //     }
    //   });
    //   this.columns = res.data.obj;
    // },
    // onConfirmNation(value) {
    //   this.selectdata = value;
    //   this.showNation = false;
    //   this.Toast("切换成功");
    // },
    // btn(num) {
    //   switch (num) {
    //     case 1:
    //       this.Toast("此功能暂未开通");
    //       break;
    //     case 2:
    //       this.Toast("此功能暂未开通");
    //       break;
    //     case 3:
    //       this.$router.push("/GeneralList");
    //       break;
    //     default:
    //       break;
    //   }
    // },
    /** 初始化住院信息与日历可选范围，并默认查询日清单 */
    async getInfo() {
      // let map = {
      //   patientId: "151442",
      //   userId: "111"
      // };
      // let res = await getIpPatient(map);
      // res.data.obj.resultData.forEach(item => {
      //   if (!item.outtime) {
      //     this.info = item;
      //   }
      // });
      this.detailedUser =
        this.detailedUser && this.detailedUser.inpNo
          ? this.detailedUser
          : safeJson(sessionStorage.getItem("detailedUser"), {});
      this.minDate1 = new Date(formatYmd(this.detailedUser.inpDatetime));
      // this.minDate2 = new Date(this.detailedUser.inpDatetime);
      if(this.detailedUser.outtime == "未出院"){
        const time = this.$moment(new Date()).subtract(1, "day").format("YYYY-MM-DD");
        this.maxDate1 = new Date(time);
        // this.maxDate2 = new Date(time);
        this.daystartDate = time;
      } else {
        this.maxDate1 = new Date(formatYmd(this.detailedUser.outtime));
        // this.maxDate2 = new Date(this.detailedUser.outtime);
        this.daystartDate = formatYmd(this.detailedUser.outtime);
      }
      await this.dailyList();
    },
    // 总清单
    async costList() {
      if (!this.detailedUser || !this.detailedUser.inpNo) {
        this.datalist = {};
        this.itemList = [];
        this.showList = false;
        return;
      }
      const endDate =
        this.detailedUser.outtime == "未出院"
          ? this.$moment().format("YYYY-MM-DD")
          : formatYmd(this.detailedUser.outtime);
      const map = {
        endDate,
        inpNo: this.detailedUser.inpNo,
        inpNum: this.detailedUser.inpNum,
        patientID: this.detailedUser.patientID,
        startDate: formatYmd(this.detailedUser.inpDatetime)
      };
      try {
        const res = await getIpPatBillAll(map);
        const obj = ((res || {}).data || {}).obj || {};
        const datalist = (obj.resultData || [])[0] || {};
        this.datalist = datalist;

        const groups = [
          listToGroup(datalist.anestheticFeList),
          listToGroup(datalist.bloodFeeList),
          listToGroup(datalist.bunkFeeList),
          listToGroup(datalist.checkoutFeeList),
          listToGroup(datalist.eisaiFeeList),
          listToGroup(datalist.emissionFeeList),
          listToGroup(datalist.inspectionFeeList),
          listToGroup(datalist.materialCostList),
          listToGroup(datalist.mealsFeeList),
          listToGroup(datalist.nursingFeeList),
          listToGroup(datalist.operineFeeList),
          listToGroup(datalist.otherFeeList),
          listToGroup(datalist.oxygenFeeList)
        ].filter(Boolean);

        this.itemList = groups;
        this.showList = this.itemList.length > 0;
      } catch (e) {
        this.datalist = {};
        this.itemList = [];
        this.showList = false;
      }
      // ary.push({
      //   type: res.data.obj.resultData[0].lstItem[0].itemType,
      //   name: res.data.obj.resultData[0].lstItem[0].itemTypeName,
      //   list: []
      // })
      // res.data.obj.resultData[0].lstItem.forEach(item => {
      //   flag = ary.find((it,index) => {
      //     dex = index
      //     return it.type == item.itemType
      //   })
      //   if(flag){
      //     ary[dex].list.push(item)
      //   } else {
      //     ary.push({
      //       type: item.itemType,
      //       name: item.itemTypeName,
      //       list: [item]
      //     })
      //   }
      // })
      // this.itemList = ary
    },
    // 日清单
    async dailyList(){
      if (!this.detailedUser || !this.detailedUser.inpNo) {
        this.dayLists = [];
        this.dayMoney = 0;
        return;
      }
      const map = {
        endDate: this.dayendDate ? this.dayendDate : this.daystartDate,
        inpNo: this.detailedUser.inpNo,
        inpNum: this.detailedUser.inpNum,
        patientID: this.detailedUser.patientID,
        startDate: this.daystartDate
      }
      try {
        const res = await getIpPatientBill(map);
        const obj = ((res || {}).data || {}).obj;
        const list = obj && obj.resultData && obj.resultData != 0 ? obj.resultData : [];
        this.dayLists = Array.isArray(list) ? list : [];
        this.dayMoney = toFixed2(
          this.dayLists.reduce((sum, item) => {
            const price = Math.round(Number(item.unitPrice || 0) * 100) / 100;
            const amount = Math.abs(parseInt(item.amount || 0));
            return sum + price * amount;
          }, 0)
        );
      } catch (e) {
        this.dayLists = [];
        this.dayMoney = 0;
      }
    },
    /** 事件：打开单日选择日历（原 action-sheet 已废弃） */
    selectTime() {
      this.showdanSel = true;
    },
    onConfirmDan(data) {
      this.showdanSel = false;
      this.daystartDate = this.$moment(data).format("YYYY-MM-DD");
      this.dayendDate = "";
      this.dailyList();
    },
    // onConfirmMore(data) {
    //   this.showMoreSel = false;
    //   let [start,end] = data;
    //   this.daystartDate = this.$moment(start).format("YYYY-MM-DD");
    //   this.dayendDate = this.$moment(end).format("YYYY-MM-DD");
    //   this.section = this.daystartDate + " 至 " + this.dayendDate;
    //   this.dailyList()
    // }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f9f9f9;
  .patient {
    padding: 6px 10px;
    display: flex;
    flex-flow: row nowrap;
    background: #318fe6;
    color: #fff;
    font-size: 16px;
    align-items: center;
    .name {
      flex: 1;
    }
    > img {
      width: 10px;
      height: 18px;
    }
  }
  /deep/ .van-tabs {
    border-top: 1px solid #f9f9f9;
    border-bottom: 1px solid #f9f9f9;
    .van-tab__text--ellipsis {
      letter-spacing: 1px;
      font-size: 16px;
      font-weight: 600;
    }
    .van-tabs__line {
      background-color: #3c9ecf !important;
    }
  }
  // .serve{
  //   display: flex;
  //   flex-flow: column nowrap;
  //   padding: 0px 10px;
  //   >li{
  //     text-align: center;
  //     padding: 20px 0px;
  //     margin-top: 10px;
  //     background: #fff;
  //     border: 1px solid #eee;
  //     letter-spacing: 1px;
  //     font-size: 16px;
  //     font-weight: bolder;
  //     color: rgb(80, 80, 80);
  //     background: rgba(132, 195, 255, 0.6);
  //   }
  // }
  .empty_cl{
    text-align: center;
    >img{
      width: 100%;
    }
    >span{
      font-size: 16px;
      letter-spacing: 1px;
      color: rgba(153, 153, 153, 0.8);
    }
  }
  .day_detailed {
    .time_date {
      display: flex;
      font-size: 14px;
      padding: 12px 16px;
      color: #999;
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }
    .serialNum{
      padding: 12px 16px;
      background: #fff;
      font-size: 16px;
      font-weight: bold;
    }
    .danlistcl{
      background: #fff;
      margin-top: 10px;
      display: flex;
      flex-flow: column nowrap;
      .allMoney{
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
        padding: 8px 16px;
        font-size: 14px;
        >span{
          font-weight: bold;
        }
        >span:nth-child(2){
          color: #318fe6;
        }
        >span:nth-child(3){
          position: relative;
          left: -2px;
          color: #318fe6;
          font-weight: normal;
        }
      }
      >li{
        display: flex;
        flex-flow: row nowrap;
        padding: 10px 16px;
        border-top: 1px solid #ddd;
        justify-content: space-between;
        align-items: center;
        >span{
          width: 55px;
          text-align: center;
        }
        >span:nth-child(1){
          width: 130px;
          text-align: left;
        }
      }
      .title_cl{
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .all_detailed {
    .time_date {
      font-size: 14px;
      padding: 12px 16px;
      color: #999;
      text-align: right;
    }
    .price_cl {
      background: #fff;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      > li {
        padding: 12px 16px;
        border-bottom: 1px solid #f1f1f1;
      }
    }
    .cost_detailed {
      padding: 10px 16px;
      font-size: 16px;
      letter-spacing: 1px;
      background: rgba(132, 195, 255, 0.6);
      font-weight: bolder;
      color: rgb(80, 80, 80);
    }
    .top {
      display: flex;
      flex-flow: row nowrap;
      background: #f1f1f1ad;
      padding: 12px 16px;
      font-size: 14px;
      justify-content: space-between;
      > li {
        width: 55px;
        text-align: center;
      }
      > li:nth-child(1) {
        width: 130px;
        // text-align: left;
      }
    }
    /deep/ .conlist {
      .van-collapse-item {
        border-top: 1px solid #ddd;
      }
      .van-cell {
        background: #f1f1f17e;
      }
      .van-collapse-item__content {
        padding: 0px;
      }
      .tableCl {
        display: flex;
        flex-flow: column nowrap;
        > li {
          display: flex;
          flex-flow: row nowrap;
          border-bottom: 1px solid #ddd;
          padding: 10px 16px;
          justify-content: space-between;
          align-items: center;
          color: black;
          font-size: 14px;
          > span {
            line-height: 20px;
            width: 55px;
            text-align: center;
          }
          > span:nth-child(1) {
            width: 130px;
            // text-align: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Service/Service.vue